import { validate } from 'bitcoin-address-validation';

export const isValidBtcTransaction = (v: string) => /^[a-fA-F0-9]{64}$/gis.test(v.trim());
export const isValidBtcBlockTransaction = (v: string) =>
  /^[0]{8}[a-fA-F0-9]{56}$/gis.test(v.trim());
export const isValidBtcAddress = (v: string) => validate(v.trim());
